import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PriceHighService {

  constructor() { }

  // sortKeys(amountHigh: any): any[] {
  //   const orderedKeys = { price_current: 'Current Fare', price_diff: 'Difference Amount' };  // price_previous: 'Previous Fare',
  //   return [
  //     ...Object.entries(orderedKeys)
  //       .filter(([key]) => key in amountHigh)
  //       .map(([key, newKey]) => ({ key: newKey, value: amountHigh[key] })),
  //     ...Object.keys(amountHigh)
  //       .filter(key => !(key in orderedKeys))
  //       .map(key => ({ key, value: amountHigh[key] }))
  //   ];
  // }

  sortKeys(amountHigh: any): any[] {
    const orderedKeys = { price_current: 'Current Fare', price_diff: 'Difference Amount' }; // Exclude price_previous
    return [
        ...Object.entries(orderedKeys)
          .filter(([key]) => key in amountHigh)
          .map(([key, newKey]) => ({ key: newKey, value: amountHigh[key] })),
        ...Object.keys(amountHigh)
          .filter(key => !(key in orderedKeys) && key !== 'price_previous') // Exclude price_previous
          .map(key => ({ key, value: amountHigh[key] }))
      ];
    }

  

  
}
